import React, { useState } from 'react';
import {
  Box,
  Typography,
  makeStyles,
  Card,
  CardContent,
  Tabs,
  Tab,
} from '@material-ui/core';


const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },

  tabs: {
    marginBottom: theme.spacing(2),
    borderRadius: '5px',
    '& .MuiTabs-indicator': {
      backgroundColor: '#1976d2',
    },
    '& .MuiTab-wrapper': {
      whiteSpace: 'normal',
      lineHeight: 1.2,
    },
  },
  tab: {
    minWidth: 'auto',
    fontSize: '0.75rem',
    textTransform: 'none',
    fontWeight: 500,
    width: 100,
    height: 'auto',
    minHeight: 48,
    padding: theme.spacing(1, 2),
    '& .MuiTab-wrapper': {
      whiteSpace: 'normal',
      wordWrap: 'break-word',
      textAlign: 'center',
    },
  },
  promptsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  },
  promptCard: {
    borderRadius: '10px',
    marginBottom: theme.spacing(1.5),
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    border: `1px solid ${theme.palette.grey[200]}`,
    '&:hover': {
      transform: 'translateY(-1px)',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
      border: '1px solid #B3D9FF',
    },
    '&:active': {
      transform: 'translateY(0)',
    },
  },
  promptContent: {
    padding: `${theme.spacing(1.5)}px !important`,
  },
  promptTitle: {
    fontWeight: 600,
    fontSize: '0.875rem',
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(0.5),
    lineHeight: 1.3,
  },
  promptDescription: {
    fontSize: '0.75rem',
    color: theme.palette.text.secondary,
    lineHeight: 1.4,
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
  },
}));

interface PromptsTabProps {
  onPromptSelect?: (prompt: string) => void;
  prompts?: Record<string, any[]>;
}

export const PromptsTab: React.FC<PromptsTabProps> = ({
  onPromptSelect,
  prompts,
}) => {
  const classes = useStyles();
  const [activeTab, setActiveTab] = useState(0);
  const agentPrompts = prompts || {};
  const categories = Object.keys(agentPrompts);
  const activeCategory = categories[activeTab];
  const activePrompts = agentPrompts[activeCategory] || [];

  const handlePromptClick = (prompt: any) => {
    onPromptSelect?.(prompt.description);
  };

  return (
    <Box className={classes.root}>
      <Tabs
        value={activeTab}
        onChange={(_, newValue) => setActiveTab(newValue)}
        className={classes.tabs}
        variant="scrollable"
        scrollButtons="auto"
      >
        {categories.map((category, index) => (
          <Tab key={index} label={category} className={classes.tab} />
        ))}
      </Tabs>
      <Box className={classes.promptsContainer}>
        {activePrompts.map(prompt => (
          <Card
            key={prompt.id}
            className={classes.promptCard}
            onClick={() => handlePromptClick(prompt)}
            elevation={0}
          >
            <CardContent className={classes.promptContent}>
              <Typography className={classes.promptTitle}>
                {prompt.title}
              </Typography>
              <Typography className={classes.promptDescription}>
                {prompt.description}
              </Typography>
            </CardContent>
          </Card>
        ))}
      </Box>
    </Box>
  );
};
